import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

const SMALL_MOBILE = '(max-width: 399px)';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  width: 100%;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space[5]};
  width: 100%;

  @media ${SMALL_MOBILE} {
    gap: ${space[4]};
  }
`;

export const Thumbnail = styled.div`
  flex-shrink: 0;
  width: ${space[11]};
  height: ${space[11]};
  border-radius: ${layout.borderRadius};
  overflow: hidden;
  background: ${colors.lighterGrey};

  @media ${SMALL_MOBILE} {
    width: ${space[9]};
    height: ${space[9]};
  }
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
  text-align: center;
  padding: ${space[2]};
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  gap: ${space[5]};
  align-items: flex-start;

  @media ${SMALL_MOBILE} {
    gap: ${space[4]};
  }
`;

export const TextColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontPrimary};
  line-height: 1.4;
`;

export const MetaList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const MetaItem = styled.li`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
  line-height: 1.4;
`;

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  flex-shrink: 0;
  gap: ${space[1]};
`;

export const SubPriceRow = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontSecondary};
  line-height: 1.4;
`;

export const RemoveRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const RemoveButton = styled.button`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontPrimary};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  line-height: 1.4;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;
